import React from "react";
import Footer from "../page/Footer";
import CoursesInfo from "../page/CoursesInfo";
import Header from "../page/Header";

const CoursesH = () => {
 
  return (
  <>
  <Header/>
  
  <br/>
      <br/>
      
     
  <CoursesInfo/>
  <Footer/>
  
  </>
  );
};

export default CoursesH;